import { Realizado } from './realizado';

/** Dados de um mês para os KPI's de produtividade */
export class Mes {
    mes: number;
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<Mes>) {
        Object.assign(this, props);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Mes {
        return new Mes(JSON.parse(json));
    }
}
